import React from 'react';
import {Skeleton, Stack} from '@mui/material';
import {Body, Button, Headline} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import Modal from '@/components/modal';
import styles from './G2ReviewModal.module.scss';

interface G2ReviewModalProps {
  open: boolean;
  reviewUrl?: string;
  status: 'idle' | 'loading' | 'error' | 'success';
  onClose: () => void;
  onRetry: () => void;
}

export default function G2ReviewModal({
  open,
  reviewUrl,
  status,
  onClose,
  onRetry,
}: G2ReviewModalProps) {
  const showLoading = status === 'idle' || status === 'loading';
  const showError = status === 'error' || (status === 'success' && !reviewUrl);
  const showEmbed = Boolean(reviewUrl) && !showError && !showLoading;

  return (
    <Modal
      open={open}
      size="small"
      onClose={onClose}
      showCloseButton
      contentClassName={
        showError ? styles.messageContainer : styles.embedContainer
      }
      testID="g2-review-modal"
    >
      <>
        {showLoading && (
          <Skeleton
            className={styles.skeleton}
            variant="rectangular"
            data-testid="g2-review-loading"
          />
        )}
        {showError && (
          <Stack alignItems="center" spacing={2}>
            <Headline size="md">
              {translate('We could not load the G2 review form')}
            </Headline>
            <Body size="md">{translate('Please try again in a moment.')}</Body>
            <Button
              appearance="brand"
              mode="filled"
              size="large"
              onClick={onRetry}
            >
              {translate('Try again')}
            </Button>
          </Stack>
        )}
        {showEmbed && (
          <iframe
            className={styles.iframe}
            src={reviewUrl}
            title={translate('Review Popular Pays on G2')}
          />
        )}
      </>
    </Modal>
  );
}
